/*@ngInject*/
const KeepAliveMediator = function (keepAliveRepository, persistentConnection, preferenceModel) {

    this.keepAlive = function () {
        return keepAliveRepository.keepAlive();
    };

    this.keepAliveDisconnectOnError = function () {
        const requestTimeout = preferenceModel.get('system.keepAliveRequestTimeout') || 15000;

        return keepAliveRepository.keepAlive(requestTimeout).then(null, function (result) {
            // On keepAlive ping error:
            // Check that 'result' is nil, indicating that the server did not respond to the request.
            if (_.isNil(result)) {
                persistentConnection.disconnectAndAlert();
            }
        });
    };
};

angular.module('umCore')
    .service('keepAliveMediator', KeepAliveMediator);
